export default __webpack_public_path__ + "static/media/arrows_clockwise.8195931c.svg";